import React, { Suspense } from "react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";

import DashboardSkeleton from "../components/common/DashboardLoader";
import Navbar from "../components/navbar/Main";
import Sidebar from "../components/Sidebar";

// Used on routes where authentication is required
const RequireAuth = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isUserLoggedIn = localStorage.getItem("token");
  const [lowLicensesTxt, setLowLicensesTxt] = useState("");
  const [lowLicensesInfoShown, setLowLicensesInfoShown] = useState(true);
  const userProfile = useSelector((e) => e.profile.userProfile);

  useEffect(() => {
    // check billing licenses data
    if (userProfile?.type === "client_admin") {
      if (userProfile?.cl_licenses_count < 10) {
        setLowLicensesTxt("Your available clinical licenses are running low.");
      } else if (userProfile?.nc_licenses_count < 10) {
        setLowLicensesTxt(
          "Your available non-clinical licenses are running low."
        );
      }
    }
    // redirect to 2fa screen if 2fa is not enabled
    if (userProfile && "fa_enabled" in userProfile && !userProfile.fa_enabled) {
      navigate("/home/2FA");
    }
  }, [userProfile]);

  function isFullScreenMode() {
    const locationsList = ["/home/2FA"];
    // Remove '/' at end of location path
    let locationPathName =
      location?.pathname &&
      location.pathname.charAt(location.pathname.length - 1) === "/"
        ? location.pathname.substring(0, location.pathname.length - 1)
        : location?.pathname;
    return locationsList.includes(locationPathName);
  }

  return (
    <>
      {isUserLoggedIn ? (
        <div className="dt-ta-main-reqauth">
          {lowLicensesInfoShown && lowLicensesTxt.length > 0 && (
            <div className="animate__animated animate__fadeIn dt-ta-nav-billing-status">
              <div className="dflex dt-ta-nav-billing-status-1">
                <div className="dt-ta-nav-billing-status-1-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="48"
                    viewBox="0 -960 960 960"
                    width="48">
                    <path d="M479.982-280q14.018 0 23.518-9.482 9.5-9.483 9.5-23.5 0-14.018-9.482-23.518-9.483-9.5-23.5-9.5-14.018 0-23.518 9.482-9.5 9.483-9.5 23.5 0 14.018 9.482 23.518 9.483 9.5 23.5 9.5ZM453-433h60v-253h-60v253Zm27.266 353q-82.734 0-155.5-31.5t-127.266-86q-54.5-54.5-86-127.341Q80-397.681 80-480.5q0-82.819 31.5-155.659Q143-709 197.5-763t127.341-85.5Q397.681-880 480.5-880q82.819 0 155.659 31.5Q709-817 763-763t85.5 127Q880-563 880-480.266q0 82.734-31.5 155.5T763-197.684q-54 54.316-127 86Q563-80 480.266-80Zm.234-60Q622-140 721-239.5t99-241Q820-622 721.188-721 622.375-820 480-820q-141 0-240.5 98.812Q140-622.375 140-480q0 141 99.5 240.5t241 99.5Zm-.5-340Z" />
                  </svg>
                </div>
                <div className="dt-ta-nav-billing-status-1-2">
                  {lowLicensesTxt}
                </div>
                <div
                  className="dt-ta-nav-billing-status-1-3"
                  onClick={() => navigate("/home/billing")}>
                  Add More
                </div>
                <div
                  className="dt-ta-nav-billing-status-1-4"
                  onClick={() => setLowLicensesInfoShown(false)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="48"
                    viewBox="0 -960 960 960"
                    width="48">
                    <path d="m249-207-42-42 231-231-231-231 42-42 231 231 231-231 42 42-231 231 231 231-42 42-231-231-231 231Z" />
                  </svg>
                </div>
              </div>
            </div>
          )}
          <div className="container-fluid dt-ta-main-wrp">
            {isFullScreenMode() ? (
              <Outlet />
            ) : (
              <div className="row dt-ta-main-wrp1">
                <div className="col-sm-2 dt-ta-dash-snav dt-ta-main-wrp1_1">
                  <Sidebar />
                </div>
                <div className="col-sm-10 pl-5 pr-5 right-col dt-ta-main-wrp1_2 dt-ta-dash-body">
                  <Navbar />
                  <Suspense
                    fallback={<DashboardSkeleton loaderType="internal" />}>
                    <Outlet />
                  </Suspense>
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <Navigate to="/" state={{ from: location }} replace />
      )}
    </>
  );
};

export default RequireAuth;
